import script from "./TaskDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetail.vue?vue&type=script&setup=true&lang=js"

import "./TaskDetail.vue?vue&type=style&index=0&id=deee55a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deee55a0"]])

export default __exports__